module.exports = __webpack_public_path__ + "static/media/home.39a08aac.svg";